var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoleta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20.74 26.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_9-2);\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_9);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    "data-name": "Degradado sin nombre 9",
    x1: 0,
    y1: 13.49,
    x2: 20.74,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cd882d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#cd882d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e1b45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#edcf75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f2da80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ba8432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9-2",
    "data-name": "Degradado sin nombre 9",
    x1: 4.9,
    y1: 13.47,
    x2: 15.82,
    y2: 13.47,
    xlinkHref: "#Degradado_sin_nombre_9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.14,26.33c-.62.81-1.58.87-2.18.1l-1.62-2.08c.93-1.25.91-3.16,0-4.36s-2.39-1.22-3.34,0l-1.52-1.99c-.6-.79-.67-2.09-.03-2.92L11.67.55c.62-.8,1.62-.68,2.19.06l1.53,1.97c-.94,1.23-.9,3.14-.05,4.3.92,1.25,2.42,1.31,3.4.07l1.49,1.92c.67.86.68,2.15,0,3.03l-11.09,14.43ZM9.29,22.1l7.7-10.01c.27-.35.27-.98,0-1.33l-4.57-5.94c-.23-.3-.76-.26-.99.04L3.79,14.8c-.3.39-.33,1.01-.03,1.4l4.57,5.94c.31.24.63.27.97-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.93 6.37 15.82 11.42 8.79 20.56 4.9 15.51 11.93 6.37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoleta);
export default __webpack_public_path__ + "static/media/boleta.50eef855d49559202a405bb450229769.svg";
export { ForwardRef as ReactComponent };